import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import { TourModeGuard, TourModeProvider } from "./components/TourMode";
import { LocalizationProvider } from "./components/Localization";
import GeolocationGate from "./components/GeolocationGate";
import OrientationGuard from "./components/OrientationGuard";
import AudioTaskPage from "./pages/AudioTaskPage";
import CompletionPage from "./pages/CompletionPage";
import ExhibitPage from "./pages/ExhibitPage";
import ExplanationPage from "./pages/ExplanationPage";
import ExtraPage from "./pages/ExtraPage";
import EstateBookTaskPage from "./pages/EstateBookTaskPage";
import EstateFamilyTreeTaskPage from "./pages/EstateFamilyTreeTaskPage";
import EstatePage from "./pages/EstatePage";
import EstateScorePage from "./pages/EstateScorePage";
import EstateSoldierTaskPage from "./pages/EstateSoldierTaskPage";
import HomePage from "./pages/HomePage";
import LegacyCrestTaskPage from "./pages/LegacyCrestTaskPage";
import LegacyEscapeGamePage from "./pages/LegacyEscapeGamePage";
import LegacyPage from "./pages/LegacyPage";
import LegacyPeterTaskPage from "./pages/LegacyPeterTaskPage";
import LegacyPhoneTaskPage from "./pages/LegacyPhoneTaskPage";
import LegacyScorePage from "./pages/LegacyScorePage";
import MatchingGamePage from "./pages/MatchingGamePage";
import MirrorConsoleTaskPage from "./pages/MirrorConsoleTaskPage";
import MirrorPaintingGamePage from "./pages/MirrorPaintingGamePage";
import MirrorProjectorTaskPage from "./pages/MirrorProjectorTaskPage";
import MirrorRingsGamePage from "./pages/MirrorRingsGamePage";
import MirrorRoomPage from "./pages/MirrorRoomPage";
import MirrorScorePage from "./pages/MirrorScorePage";
import MirrorVideoLeftTaskPage from "./pages/MirrorVideoLeftTaskPage";
import MirrorVideoRightTaskPage from "./pages/MirrorVideoRightTaskPage";
import NotFoundPage from "./pages/NotFoundPage";
import OverviewPage from "./pages/OverviewPage";
import RestorationGamePage from "./pages/RestorationGamePage";
import ScorePage from "./pages/ScorePage";
import SalonPage from "./pages/SalonPage";
import SalonPeterTaskPage from "./pages/SalonPeterTaskPage";
import SalonRadioTaskPage from "./pages/SalonRadioTaskPage";
import SalonScorePage from "./pages/SalonScorePage";
import SalonTableTaskPage from "./pages/SalonTableTaskPage";
import SalonVideoTaskPage from "./pages/SalonVideoTaskPage";
import TourSetupPage from "./pages/TourSetupPage";
import WarBombingTaskPage from "./pages/WarBombingTaskPage";
import WarFigureTaskPage from "./pages/WarFigureTaskPage";
import WarRoomPage from "./pages/WarRoomPage";
import WarScorePage from "./pages/WarScorePage";

export default function App() {
  return (
    <LocalizationProvider>
      <OrientationGuard />
      <GeolocationGate>
       <TourModeProvider>
        <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <TourModeGuard>
            <div className="app-shell">
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/tarlatvezetes" element={<TourSetupPage />} />
                <Route path="/hogyan-mukodik" element={<ExplanationPage />} />
                <Route path="/attekinto" element={<OverviewPage />} />
                <Route
                  path="/rezidencia"
                  element={<ExhibitPage variant="residence" />}
                />
                <Route path="/talalo" element={<ExhibitPage variant="dining" />} />
                <Route path="/talalo/feladat" element={<AudioTaskPage />} />
                <Route path="/talalo/parositas" element={<MatchingGamePage />} />
                <Route path="/talalo/restauralas" element={<RestorationGamePage variant={1} />} />
                <Route path="/talalo/restauralas-2" element={<RestorationGamePage variant={2} />} />
                <Route path="/talalo/eredmeny" element={<ScorePage />} />
                <Route path="/tukorterem" element={<MirrorRoomPage />} />
                <Route
                  path="/tukorterem/vetites"
                  element={<MirrorProjectorTaskPage />}
                />
                <Route
                  path="/tukorterem/video-bal"
                  element={<MirrorVideoLeftTaskPage />}
                />
                <Route
                  path="/tukorterem/video-jobb"
                  element={<MirrorVideoRightTaskPage />}
                />
                <Route
                  path="/tukorterem/konzol"
                  element={<MirrorConsoleTaskPage />}
                />
                <Route
                  path="/tukorterem/festmeny"
                  element={<MirrorPaintingGamePage variant={1} />}
                />
                <Route path="/tukorterem/festmeny-2" element={<MirrorPaintingGamePage variant={2} />} />
                <Route path="/tukorterem/gyuruk" element={<MirrorRingsGamePage />} />
                <Route path="/tukorterem/eredmeny" element={<MirrorScorePage />} />
                <Route path="/szalon" element={<SalonPage />} />
                <Route path="/szalon/peter" element={<SalonPeterTaskPage />} />
                <Route path="/szalon/terites" element={<SalonTableTaskPage />} />
                <Route path="/szalon/radio" element={<SalonRadioTaskPage />} />
                <Route path="/szalon/video" element={<SalonVideoTaskPage />} />
                <Route path="/szalon/eredmeny" element={<SalonScorePage />} />
                <Route path="/petkiek" element={<EstatePage />} />
                <Route path="/petkiek/konyv" element={<EstateBookTaskPage />} />
                <Route path="/petkiek/katona" element={<EstateSoldierTaskPage />} />
                <Route path="/petkiek/csaladfa" element={<EstateFamilyTreeTaskPage />} />
                <Route path="/petkiek/eredmeny" element={<EstateScorePage />} />
                <Route path="/mariaffiek" element={<LegacyPage />} />
                <Route path="/mariaffiek/peter" element={<LegacyPeterTaskPage />} />
                <Route path="/mariaffiek/cimer" element={<LegacyCrestTaskPage />} />
                <Route path="/mariaffiek/menekules/jatek" element={<LegacyEscapeGamePage />} />
                <Route path="/mariaffiek/telefon" element={<LegacyPhoneTaskPage />} />

                <Route path="/mariaffiek/eredmeny" element={<LegacyScorePage />} />
                <Route path="/vilaghaboru" element={<WarRoomPage />} />
                <Route path="/vilaghaboru/alak" element={<WarFigureTaskPage />} />
                <Route path="/vilaghaboru/bombazas" element={<WarBombingTaskPage />} />
                <Route path="/vilaghaboru/eredmeny" element={<WarScorePage />} />
                <Route path="/extra" element={<ExtraPage />} />
                <Route path="/befejezes" element={<CompletionPage />} />
                <Route path="*" element={<NotFoundPage />} />
              </Routes>
            </div>
          </TourModeGuard>
        </BrowserRouter>
       </TourModeProvider>
      </GeolocationGate>
    </LocalizationProvider>
  );
}
